import { Stack, Tooltip, Typography } from "@mui/material";
import {
  IconButton,
  useCornerRadius,
  useFoundationColorTokens,
  useSpacing,
  useTypography,
} from "@surya-digital/leo-reactjs-material-ui";
import { observer } from "mobx-react";
import React from "react";

export interface EmailCycleDeliveryStatsCardProps {
  icon: React.ReactElement;
  label: string;
  count: number;
  color: string;
  backgroundColor: string;
  actionButtonName?: string;
  actionIcon?: React.ReactElement;
  actionLabel?: string;
  onActionClick?: VoidFunction;
  isActionLoading?: boolean;
  isActionDisabled?: boolean;
}

export const EmailCycleDeliveryStatsCard: React.FC<EmailCycleDeliveryStatsCardProps> =
  observer(
    ({
      icon,
      label,
      count,
      color,
      backgroundColor,
      actionButtonName,
      actionIcon,
      actionLabel,
      onActionClick,
      isActionLoading,
      isActionDisabled,
    }) => {
      const cornerRadius = useCornerRadius();
      const spacing = useSpacing();
      const typography = useTypography();
      const tokens = useFoundationColorTokens();

      return (
        <Stack
          bgcolor={backgroundColor}
          padding={spacing.spaceXL}
          paddingBottom={spacing.spaceMD}
          gap={spacing.spaceLG}
          borderRadius={cornerRadius.radiusXS}
          alignItems="center"
          justifyContent="center"
          height="100%"
          position="relative"
        >
          {actionIcon && onActionClick && actionButtonName && actionLabel ? (
            <Stack
              position="absolute"
              top={spacing.spaceMD}
              right={spacing.spaceMD}
            >
              <Tooltip title={actionLabel}>
                <span>
                  <IconButton
                    name={actionButtonName}
                    size="small"
                    icon={actionIcon}
                    variant="plain-neutral"
                    hoverColor="buttonOnSurfaceIcon"
                    loading={isActionLoading}
                    disabled={isActionDisabled}
                    onClick={onActionClick}
                  />
                </span>
              </Tooltip>
            </Stack>
          ) : null}
          <Stack
            color={color}
            borderRadius={cornerRadius.radiusMax}
            padding={spacing.spaceMD}
            bgcolor={tokens.background}
          >
            {icon}
          </Stack>
          <Stack gap={spacing.spaceXXS} alignItems="center">
            <Typography {...typography.b2} color={color} textAlign="center">
              {label}
            </Typography>
            <Typography {...typography.h4} color={color}>
              {count}
            </Typography>
          </Stack>
        </Stack>
      );
    },
  );
